import { Dialog, Stack } from "@mui/material";
import { RegionRequirementStep } from "Components/ProfileCompletion/RegionRequirementStep";
import {
  type ProfileRequirementKey,
  useProfileRequirements,
} from "Components/ProfileCompletion/useProfileRequirements";
import type { ComponentType } from "react";

const REQUIREMENT_STEPS: Record<ProfileRequirementKey, ComponentType> = {
  region: RegionRequirementStep,
};

/**
 * The single "add missing information before continuing" surface: renders the first unmet
 * requirement from useProfileRequirements in one blocking dialog. When a requirement is
 * satisfied (its user-info flag clears on refresh), the chain advances to the next one.
 * All current requirements are blocking; if a dismissable one ever returns, git history has
 * the per-session dismissal machinery (session-keyed "later" button) this once carried.
 */
export const ProfileCompletionModal = () => {
  const requirements = useProfileRequirements();
  const current = requirements[0];

  if (!current) {
    return null;
  }

  const StepContent = REQUIREMENT_STEPS[current.key];

  return (
    <Dialog
      open
      fullWidth
      maxWidth="xs"
      disableEscapeKeyDown
      slotProps={{
        paper: {
          sx: { boxShadow: "none", borderRadius: "10px", width: "100%" },
        },
      }}
    >
      <Stack p={5} gap={3}>
        <StepContent />
      </Stack>
    </Dialog>
  );
};
